import {GeneratedDocumentList} from "./GeneratedDocumentList";
import {ProcessCard} from "./ProcessCard";
import {ProcessNames} from "../api/types";
import {Loader} from "@aws-amplify/ui-react";

export const GeneratePickingList = () => <ProcessCard title='Generate picking list'
                                                       processName={ProcessNames.GENERATE_PICKING_LIST}
                                                       resultMessage="Your request to generate picking list has been successfully initiated. The resulting file will be available for download within the next 2-5 minutes.">
  {(processStatus) => processStatus?.isRunning === false ? <GeneratedDocumentList processName={ProcessNames.GENERATE_PICKING_LIST}/> : <Loader size='large' ariaLabel="Loading..."/>}
</ProcessCard>